import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { sendPatchRequestApi } from "../../../services/service";

const initialState = {
  data: {},
  status: "idle",
  loading: false,
  error: "",
};

// Define the async thunk for applying for a job
export const updateMcq = createAsyncThunk("updateMcq", async ({id,status}) => {
  try {
    const response = await  sendPatchRequestApi(`/mcq/${id}`,{status:status});
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
});

export const updateCoding = createAsyncThunk("updateCoding", async ({id,status}) => {
    try {
      const response = await  sendPatchRequestApi(`/coding/${id}`,{status:status});
      return response;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  });

  export const updateBehavioural = createAsyncThunk("updateBehavioural", async ({id,status}) => {
    try {
      const response = await  sendPatchRequestApi(`/behavior/${id}`,{status:status});
      return response;
    } catch (error) {
      console.error("API Error:", error);
      throw error;
    }
  });

  

const patchApiSlice = createSlice({
  name: "patchApi",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateMcq.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateMcq.fulfilled, (state, action) => {
        state.status = "idle";
        state.data.updateMcqData = action.payload;
      })

      .addCase(updateMcq.rejected, (state, action) => {
        state.status = "idle";
        state.data.updateMcqData = {
          status: "failed ",
          message: `${action.error.name} : ${action.error.message}`,
        };
      })

      .addCase(updateCoding.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateCoding.fulfilled, (state, action) => {
        state.status = "idle";
        state.data.updateCodingData = action.payload;
      })

      .addCase(updateCoding.rejected, (state, action) => {
        state.status = "idle";
        state.data.updateCodingData = {
          status: "failed ",
          message: `${action.error.name} : ${action.error.message}`,
        };
      })

      .addCase(updateBehavioural.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateBehavioural.fulfilled, (state, action) => {
        state.status = "idle";
        state.data.updateBehaviouralData = action.payload;
      })

      .addCase(updateBehavioural.rejected, (state, action) => {
        state.status = "idle";
        state.data.updateBehaviouralData = {
          status: "failed ",
          message: `${action.error.name} : ${action.error.message}`,
        };
      })
  },
});

export default patchApiSlice.reducer;
